"use client";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faCartCirclePlus } from "@fortawesome/pro-solid-svg-icons";
import { usePageVariantContext } from "@tosize/ui";
import type { ReactNode } from "react";
import { useCommand } from "../../Context";
import { CommandItem } from "../../utils/Item";

export function SimpleCommandItemProduct({ title }: { title: string }) {
	const { importProductsCallback } = useCommand();

	return (
		<CommandItem icon={faCartCirclePlus} shortcut="m" onSelect={() => importProductsCallback()}>
			{title}
		</CommandItem>
	);
}

export function FurnitureProductWrapper({ children }: { children: ReactNode }) {
	const { variant } = usePageVariantContext();

	if (variant !== "tosize_furniture") {
		return null;
	}

	return children;
}

interface CommandItemDispatchEventProps {
	title: string;
	icon: IconProp;
	shortcut: string;
	metaKey?: boolean;
	shiftKey?: boolean;
}

export function CommandItemDispatchEvent(props: CommandItemDispatchEventProps) {
	const { title, icon, shortcut, metaKey = false, shiftKey = true } = props;
	const { onOpenChangeHandler } = useCommand();

	const shortcutKey = shiftKey && !metaKey ? shortcut.toUpperCase() : shortcut;

	return (
		<CommandItem
			icon={icon}
			shortcut={shortcut}
			metaKey={metaKey}
			shiftKey={shiftKey}
			onSelect={() => {
				onOpenChangeHandler(false);
				window.dispatchEvent(new KeyboardEvent("keydown", { metaKey, shiftKey, key: shortcutKey }));
			}}
		>
			{title}
		</CommandItem>
	);
}
